import { render, staticRenderFns } from "./new-year-draw-pop.vue?vue&type=template&id=359737b0&scoped=true&"
import script from "./new-year-draw-pop.vue?vue&type=script&lang=js&"
export * from "./new-year-draw-pop.vue?vue&type=script&lang=js&"
import style0 from "./new-year-draw-pop.vue?vue&type=style&index=0&id=359737b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359737b0",
  null
  
)

export default component.exports